import type { UserGroupListItem } from "@/models/user-group.model";
import { NumericCell } from "@spz/ui/components/table/cells/numeric-cell";
import { TextCell } from "@spz/ui/components/table/cells/text-cell";
import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { UserGroupsActionsCell } from "../components/user-groups/user-groups-actions-cell";

export function useUserGroupsListColumns() {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<UserGroupListItem>();

  return useMemo(
    () => [
      columnHelper.accessor("name", {
        header: t("group_name"),
        enableSorting: false,
        cell: ({ getValue }) => {
          const name = getValue();
          return <TextCell value={name} showTooltip={false} maxLines={1} />;
        },
      }),
      columnHelper.accessor("description", {
        header: t("description"),
        size: Number.MAX_SAFE_INTEGER,
        enableSorting: false,
        cell: ({ getValue }) => {
          const description = getValue() ?? "-";
          return <TextCell value={description} maxLines={2} />;
        },
      }),
      columnHelper.accessor("userCount", {
        header: t("affiliated_users"),
        size: 100,
        enableSorting: false,
        cell: ({ getValue }) => {
          const userCount = getValue();
          return <NumericCell value={userCount} />;
        },
      }),
      columnHelper.display({
        id: "actions",
        size: 150,
        header: "",
        cell: ({ row }) => {
          return <UserGroupsActionsCell row={row} />;
        },
      }),
    ],
    [t, columnHelper],
  );
}
